import OneStar from '../../images/reviews/yotpo-1-star.svg';
import TwoStars from '../../images/reviews/yotpo-2-stars.svg';
import ThreeStars from '../../images/reviews/yotpo-3-stars.svg';
import FourStars from '../../images/reviews/yotpo-4-stars.svg';
import FiveStars from '../../images/reviews/yotpo-5-stars.svg';

export const mapScoreToStarSVG = (score: number) => {
  switch (score) {
    case 1:
      return OneStar;
    case 2:
      return TwoStars;
    case 3:
      return ThreeStars;
    case 4:
      return FourStars;
    default:
      return FiveStars;
  }
};
